<template>
  <div id="msg" ref="msg">
    <Badge :count="total" overflow-count="99">
      <Icon :type="false ? 'md-notifications' : 'md-notifications-outline'" size="24"
        style="cursor: pointer; color: #fff" @click="openForm = true"></Icon>
    </Badge>
    <Modal v-model="openForm" title="最新报警" footer-hide width="1200">
      <Table height="400" border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>">
        <template slot-scope="{ row, index }" slot="status">
          <Tag :title="row.state == 0 ? '' : row.stateDes" :color="status[row.state].color">{{ status[row.state].name }}
          </Tag>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Button size="small" @click="opemUpdate(row, index)">纠正</Button>
          <Button size="small" @click="guiji(row, index)">轨迹</Button>
        </template>
      </Table>
    </Modal>

  </div>
</template>
<script>

var deviceList = [];
var alarms = [];
export default {
  data() {
    return {
      openForm: false,
      total: 0,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
          width: 100,
        },
        {
          title: "单位名称",
          key: "groupName",
          width: 150,
        },
        {
          title: "设备号",
          key: "deviceNo",
        },
        {
          title: "报警类型",
          key: "alarmTypeName",
        },
        {
          title: "报警时间",
          key: "alarmTime2",
        }, {
          title: "报警地点",
          key: "startAdd",
          width: 300
        },

      ],
      tableData: [],
      searchItem: {
        //pageNumber: 1,
        //pageSize:20,
      },

    };
  },

  methods: {
    getList() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-common-server-alarm/alarm/focus",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        this.total = data.length;
        for (let i = 0; i < data.length; i++) {
          data[i].alarmTime2 = this.utils.time(data[i].alarmTime);
        }
        this.tableData = data;
      });


    },
  },
  mounted() {
    this.getList();
    setInterval(() => {
      this.getList();
    }, 1000 * 60 * 5);
  },
};
</script>
<style lang="">
#msg {
  float: left;
  margin-top: 14px;
  margin-right: 16px;
}
#msg i {
  font-size: 24px;
  color: var(--fontColor);
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/sys/msg.vue